import { useCallback, useContext, useState } from 'react';
import { AuthContext, AuthContextValue } from './AuthProvider';
import { ApiError, toApiError } from '../network/mainClient/apiError';

export const usePasswordChange = (): [
  boolean | null,
  boolean,
  ApiError | null,
  (operationsSessionId: string | undefined, factorId: string, code: string, newPassword: string) => Promise<void>
] => {
  const { changePassword } = useContext<AuthContextValue>(AuthContext);
  const [result, setResult] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<ApiError | null>(null);

  const request = useCallback(async (
    operationsSessionId: string | undefined,
    factorId: string,
    code: string,
    newPassword: string
  ) => {
    setIsLoading(true);
    setResult(false);
    setError(null);

    try {
      await changePassword(operationsSessionId || "", factorId, code, newPassword);
      setResult(true);
    } catch (e) {
      setError(toApiError(e));
      throw e;
    } finally {
      setIsLoading(false);
    }
  }, [changePassword]);

  return [result, isLoading, error, request];
};
